import React from "react";

export default function Scale({ imc }) {

    const calculateLeftPosition = (imc) => {
        // Handle edge cases
        if (imc < 14.5) return '0%'; // IMC less than 15.6
        if (imc > 45) return '100%'; // IMC greater than 45

        // Calculate position within specific ranges
        if (imc >= 14.5 && imc < 16.5) {
            // Map 15.6 to 16.5 to 0% to 11%
            return `${((imc - 14.5) / (16.5 - 14.5)) * 11}%`;
        }
        if (imc >= 16.5 && imc < 18.5) {
            // Map 16.5 to 18.5 to 11% to 21%
            return `${11 + ((imc - 16.5) / (18.5 - 16.5)) * 10}%`;
        }
        if (imc >= 18.5 && imc < 25) {
            // Map 18.5 to 25 to 21% to 53%
            return `${21 + ((imc - 18.5) / (25 - 18.5)) * 32}%`;
        }
        if (imc >= 25 && imc < 30) {
            // Map 25 to 30 to 53% to 64%
            return `${53 + ((imc - 25) / (30 - 25)) * 11}%`;
        }
        if (imc >= 30 && imc < 35) {
            // Map 30 to 35 to 64% to 75%
            return `${64 + ((imc - 30) / (35 - 30)) * 11}%`;
        }
        if (imc >= 35 && imc < 40) {
            // Map 35 to 40 to 75% to 89%
            return `${75 + ((imc - 35) / (40 - 35)) * 14}%`;
        }
        if (imc >= 40 && imc <= 45) {
            // Map 40 to 45 to 89% to 100%
            return `${89 + ((imc - 40) / (45 - 40)) * 11}%`;
        }
    };




    return (
        <>
            <div class="flex h-7 mx-auto mt-4 relative">
                <div className="rounded-l-lg w-[11%] flex items-center justify-center bg-blue-600 text-white font-bold"></div>
                <div className="w-[10%] flex items-center justify-center bg-blue-500 text-white font-bold"></div>
                <div className="w-[32%] flex items-center justify-center bg-green-500 text-white font-bold"></div>
                <div className="w-[11%] flex items-center justify-center bg-red-400 text-white font-bold"></div>
                <div className="w-[11%] flex items-center justify-center bg-red-500 text-white font-bold"></div>
                <div className="w-[14%] flex items-center justify-center bg-red-600 text-white font-bold"></div>
                <div className="rounded-r-lg w-[11%] flex items-center justify-center bg-red-700 text-white font-bold"> </div>
                <div>
                    {imc && (
                        <div
                            id="pointer"
                            style={{ left: calculateLeftPosition(imc) }}
                            className="shadow-xl w-[6px] h-[45px] absolute top-[-38%] bg-black rounded
                 transition-all duration-500 ease-out transform -translate-x-full"
                        ></div>
                    )}
                </div>
            </div>
            <div className="w-[95%] h-7 mx-auto relative">
                <div className="cursor-default font-semibold absolute text-sm top-2 left-[3%] sm:left-[5%]">16,5</div>
                <div className="cursor-default font-semibold absolute text-sm top-2 left-[18%]">18,5</div>
                <div className="cursor-default font-semibold absolute text-sm top-2 left-[50%] sm:left-[51%]">25</div>
                <div className="cursor-default font-semibold absolute text-sm top-2 left-[63%]">30</div>
                <div className="cursor-default font-semibold absolute text-sm top-2 left-[74%]">35</div>
                <div className="cursor-default font-semibold absolute text-sm top-2 left-[88%] sm:left-[89%]">40</div>
            </div>

            <div className="mt-6 ml-4">
                <div className="flex gap-2 items-center my-1"><div className="w-[12px] h-[12px] bg-blue-600 rounded-full"></div><div className="text-sm sm:text-sm text-gray-700"><span className="font-bold">moins de 16,5</span> – dénutrition</div></div>
                <div className="flex gap-2 items-center my-1"><div className="w-[12px] h-[12px] bg-blue-500 rounded-full"></div><div className="text-sm sm:text-sm text-gray-700"><span className="font-bold">16,5 à 18,5</span> – maigreur</div></div>
                <div className="flex gap-2 items-center my-1"><div className="w-[12px] h-[12px] bg-green-500 rounded-full"></div><div className="text-sm sm:text-sm text-gray-700"><span className="font-bold">18,5 à 25</span> – poids normal</div></div>
                <div className="flex gap-2 items-center my-1"><div className="w-[12px] h-[12px] bg-red-400 rounded-full"></div><div className="text-sm sm:text-sm text-gray-700"><span className="font-bold">25 à 30</span> – surpoids</div></div>
                <div className="flex gap-2 items-center my-1"><div className="w-[12px] h-[12px] bg-red-500 rounded-full"></div><div className="text-sm sm:text-sm text-gray-700"><span className="font-bold">30 à 35</span> – obésité modérée</div></div>
                <div className="flex gap-2 items-center my-1"><div className="w-[12px] h-[12px] bg-red-600 rounded-full"></div><div className="text-sm sm:text-sm text-gray-700"><span className="font-bold">35 à 40</span> – obésité sévère</div></div>
                <div className="flex gap-2 items-center my-1"><div className="w-[12px] h-[12px] bg-red-700 rounded-full"></div><div className="text-sm sm:text-sm text-gray-700"><span className="font-bold">40 et plus</span> – obésité morbide</div></div>
            </div>
        </>
    )
}